import * as React from 'react';
import { useHistory, useLocation } from 'react-router';

export const PeopleSearchStorageKey = 'PeopleSearchStorageKey';

export const QUERY_PARAM_APP_DRAWER_VALUE = 'appDrawerValue';
export const QUERY_PARAM_DRAWER_CONTACT_ID = 'drawerContactId';

export const useContactsPageAppDrawerQueryParamState = () => {
	const location = useLocation();
	const history = useHistory();
	const searchParams = React.useMemo(() => {
		return new URLSearchParams(location.search);
	}, [location.search]);

	const activeDrawer = searchParams.get(QUERY_PARAM_APP_DRAWER_VALUE);
	const drawerContactId = searchParams.get(QUERY_PARAM_DRAWER_CONTACT_ID);
	const setDrawerValue = (value: string) => {
		searchParams.set(QUERY_PARAM_APP_DRAWER_VALUE, value);
		history.push(history.location.pathname + '?' + searchParams.toString());
	};
	const setDrawerToContactInfo = (contactId: string) => {
		if (!contactId) {
			return;
		}
		searchParams.set(QUERY_PARAM_APP_DRAWER_VALUE, 'contact-info');
		searchParams.set(QUERY_PARAM_DRAWER_CONTACT_ID, contactId);
		history.push(history.location.pathname + '?' + searchParams.toString());
	};
	const clearDrawerValue = () => {
		searchParams.delete(QUERY_PARAM_APP_DRAWER_VALUE);
		history.push(history.location.pathname + '?' + searchParams.toString());
	};

	return {
		activeDrawer,
		drawerContactId,
		setDrawerValue,
		setDrawerToContactInfo,
		clearDrawerValue,
	};
};
